import React from 'react';

/**
 * HeadlineAccent
 *
 * The single permitted accent inside a heading on Sampler is `#8B5CF6` purple,
 * applied to at most one word per headline. This component bakes that rule in
 * so future heroes / section headings can't drift back to multi-colour
 * gradients or arbitrary highlight colours via copy-paste.
 *
 * Usage:
 *   <h1>Hire based on <HeadlineAccent>proof</HeadlineAccent> — not CVs.</h1>
 *
 * The colour is intentionally NOT overridable.
 */
export const HeadlineAccent = ({ children, className = '', ...rest }) => (
    <span
        {...rest}
        className={className}
        style={{ color: '#8B5CF6' }}
    >
        {children}
    </span>
);

export default HeadlineAccent;
